<mat-form-field [appearance]="appearance" class="form-control-container">
  <mat-label>{{ label | translate }}</mat-label>
  <input
    matInput
    [matDatepicker]="picker"
    [formControl]="control"
    [min]="minDate"
    [max]="maxDate"
    (dateChange)="onDateChange($event)"
  />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
  <mat-hint>{{ hint | translate }}</mat-hint>
  <mat-error><wai-form-error [formField]="control"></wai-form-error></mat-error>
</mat-form-field>
